<template>
  <!-- reagent link-->
		<div class="modal fade" id="linkModal" tabindex="-1" role="dialog">
			<div class="modal-dialog">
				<!-- Modal content-->
				<div class="modal-content dir-rtl">
						<div class="modal-body ">
							<button type="button" class="btn-close" data-bs-dismiss="modal" id="linkModalCloseBTN"></button>
							<div>
								<h3 class="text-center" style="font-size:16px;font-weight: 600;">اشتراک گذاری کد معرف</h3>
								<small class="agileinfo_sign" style="display:inline-block;text-align:center;;margin-bottom: 0;">لطفا موبایل شخصی که میخواهید کد معرفتان به ایشان پیامک شود وارد نمایید.</small>
								<div class="form-group " style="margin-top:25px	">
								<input class="form-control dir-rtl "  v-model="mobile" type="text" placeholder="شماره همراه" style="height: 49px"  >
                           		 <span style="color:red">{{validMessage}}</span>
									<button class="btn btn-primary valid-btn"  @click="sendCode">ارسال کد معرف</button>
									<span class="mt-2" style="font-size:16px;font-weight: 600;">{{flageText}}</span>
								</div>
							</div>
					</div>
				</div>
			</div>
		</div>
</template>

<script setup>
import axios from 'axios';
import { ref } from 'vue';

let mobile = ref()
let flageText = ref()
function sendCode(){
	flageText.value = '';
	if(mobile.value.length == 11){
		axios
		.get('https://radap.ir/Backend/api/account/link/send.php?mobile='+mobile.value)
		.then(()=>{
		flageText.value = 'پیامک با موفقیت ارسال شد...'
		setTimeout(()=>{flageText.value = ''}, 1000);
		})
	}else{
		flageText.value = 'شماره موبایل اشتباه است'
		setTimeout(()=>{flageText.value = ''}, 1000);
	}
}
</script>

<style>

</style>